module.exports = __webpack_public_path__ + "img/face_with_symbols_on_mouth.d96c303f.gif";